import styled from 'styled-components';
import { isThemeColor, marginReplacer } from 'styles/utils';

export const IconStyled = styled.svg`
  width: ${props => props.theme.font.size[props.size] || props.size};
  height: ${props => props.theme.font.size[props.size] || props.size};
  display: ${props => (props.block ? 'block' : 'inline-block')};
  vertical-align: middle;
  shape-rendering: auto;
  margin: ${props => props.margin && marginReplacer(props.margin)};
`;

// export const IconStyled = styled.svg(({ theme, size, ...rest }) => ({
//   width: theme.font.size[size] || size,
//   height: theme.font.size[size] || size,
//   display: rest.block ? 'block' : 'inline-block',
//   verticalAlign: 'middle',
//   shapeRendering: 'auto',
//   margin: rest.margin && marginReplacer(rest.margin),
// }));

export const PathStyled = styled.path.attrs(props => ({
  d:
    props.theme.icons && props.theme.icons[props.pathName]
      ? props.theme.icons[props.pathName].path
      : props.theme.icons.check_circle.path,
}))`
  fill: ${props =>
    isThemeColor(props.colorPath)
      ? props.theme.color[props.colorPath]
      : props.colorPath || 'currentColor'};
  stroke-width: ${props =>
    props.theme.icons[props.pathName]
      ? props.theme.icons[props.pathName].customStroke
        ? props.theme.icons[props.pathName].customStroke
        : props.customStroke === 'regular'
        ? '1px'
        : props.customStroke === 'bold'
        ? '2px'
        : 0
      : props.theme.icons.check_circle.customStroke};
  stroke: ${props =>
    isThemeColor(props.colorPath)
      ? props.theme.color[props.colorPath]
      : props.colorPath || 'currentColor'};
`;
